<div class="modal-header">
  <h2 class="modal-title">{{ 'mbr.registration-data-retrieval.registration-timeout.title' | translate }}</h2>
</div>
<div class="modal-body">
  {{ 'mbr.registration-data-retrieval.registration-timeout.text' | translate }}
</div>
<div class="modal-footer">
  <button class="btn btn-warning" (click)="bsModalRef.hide()">
    {{ 'button.logout-and-delete-account' | translate }}
  </button>
</div>
